var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"async-btn",class:{ 'async-btn--requesting': _vm.requesting },attrs:{"disabled":_vm.requesting || _vm.disabled},on:{"click":_vm.clickHandler}},[_vm._t("default"),(_vm.requesting)?_c(_vm.inlineSpinner ? 'InlineSpinner' : 'Spinner',{tag:"component",staticClass:"async-btn__spinner",attrs:{"size":_vm.spinnerSize}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }